export default __webpack_public_path__ + "media/images/ui-bg_glass_75_e6e6e6_1x400-ae80be5461a8ee23c543be0dfd3dad02.png";